"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import { LitElement, html } from "lit";
import { property } from "lit/decorators.js";
import { STCComponentMixin } from "../../../common/mixins/stc_component_mixin";
export class KioskButton extends STCComponentMixin(LitElement) {
  handleOpenKiosk(e) {
    e.preventDefault();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    window.open(
      window["new_tutor_kiosk_session_path"]({ time_zone: timeZone }),
      "_blank",
      "width=1024,height=768,scrollbars=yes,resizable=yes,toolbar=no,directories=no,location=no,menubar=no,status=no,left=50,top=50"
    );
    if (this.shouldRedirect === true) {
      window.location.replace("/sessions/handle_sso_before_kiosk_start");
    }
    return false;
  }
  render() {
    return html`
      <hi-button
        class="app_switcher_btn"
        aesthetic="link"
        aria-label="Opens Kiosk, in new window"
        @trigger-ended=${(e) => this.handleOpenKiosk(e)}
      >
        <div class="app_switcher_btn_content">
          <p>Kiosk</p>
        </div>
      </hi-button>
    `;
  }
}
__decorateClass([
  property({ type: Boolean, attribute: "should-redirect" })
], KioskButton.prototype, "shouldRedirect", 2);
customElements.define("stc-kiosk-button", KioskButton);
